/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, cap: NonNullable<unknown> }} Tournament_Cap_Warning_PlayerInputs */



/**
* | output |
* | --- |
* | "This event is full ({count}/{cap}). You can still register, but there may be no seat for you." |
*
* @param {Tournament_Cap_Warning_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_cap_warning_player = /** @type {((inputs: Tournament_Cap_Warning_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Cap_Warning_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce tournoi est complet (${i?.count}/${i?.cap}). Vous pouvez encore vous inscrire, mais il n'y aura peut-être pas de place pour vous.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Este torneo está completo (${i?.count}/${i?.cap}). Aún puede inscribirse, pero puede que no haya plaza para usted.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Este torneio está lotado (${i?.count}/${i?.cap}). Você ainda pode se inscrever, mas talvez não haja vaga para você.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo torneo è completo (${i?.count}/${i?.cap}). Puoi ancora iscriverti, ma potrebbe non esserci posto per te.`)
	return /** @type {LocalizedString} */ (`This event is full (${i?.count}/${i?.cap}). You can still register, but there may be no seat for you.`)
});